/**
 * SIDCDatawarehouse
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UpdateAdjustmentCommand { 
    idLedger?: number;
    id?: number;
    reference?: string;
    transactionTypeId?: number;
    transactionTypeCode?: string;
    warehouseId?: number;
    warehouseCode?: string;
    mainSegmentId?: number;
    mainSegmentCode?: string;
    businessSegmentId?: number;
    businessSegmentCode?: string;
    branchId?: number;
    branchCode?: string;
    remarks?: string;
    total?: number;
    systemDate?: Date;
    transactionDate?: Date;
    inventoryAdjustmentDate?: Date;
    idUser?: string;
    cancelled?: number;
    status?: string;
    terminalNumber?: string;
}